// extracted by mini-css-extract-plugin
module.exports = {"root":"ManageInfluencerCategories_root__16QvD","header":"ManageInfluencerCategories_header__2qqob","title":"ManageInfluencerCategories_title__11CTy"};